
import ReceiveSquare from "../../../assets/outline/ReceiveSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiveSquareIcon({ className, dataTestid = "ReceiveSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiveSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
